import React from 'react';
import { Hero } from './components/Hero';
import { Manufacturers } from './components/Manufacturers';
import { PumpTypes } from './components/PumpTypes';
import { Applications } from './components/Applications';
import { RepairKits } from './components/RepairKits';
import { Resources } from './components/Resources';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <main className="w-full font-sans text-slate-800 bg-white" data-id="element-0">
      {/*
            Page content only — designed to be embedded between the existing
            CLR Marine WebsiteForge header and footer.
            Order is ecommerce-first: Hero → Shop by Manufacturer → Types →
            Applications → Repair Kits → Resources → FAQ → Final CTA.
          */}
      <Hero data-id="element-1" />
      <Manufacturers data-id="element-2" />
      <PumpTypes data-id="element-3" />
      <Applications data-id="element-4" />
      <RepairKits data-id="element-5" />
      <Resources data-id="element-6" />
      <FAQ data-id="element-7" />
      <FinalCTA data-id="element-8" />
    </main>;
}